// Lib
import { connect } from 'react-redux';

// Selectors
import { getCurrentBoardIdFromState } from '../../reducers/currentBoardId/currentBoardIdSelector';
import { getClosestPermissionIdForElementIdSelector } from '../../utils/permissions/permissionsSelector';

// Actions
import { validatePermissionPasswordHttp } from '../../element/elementPasswordService';
import { handlePermissionTokenResponse } from '../../utils/permissions/permissionsActions';
import { fetchBoard, prefetchPasswordProtectedCurrentBoard } from '../../element/board/boardService';

// Components
import BoardPasswordProtectedFormUI from './BoardPasswordProtectedFormUI';

// Errors
import AppError from '../../../common/error/AppError';

const onSubmitThunk =
    ({ password }) =>
    async (dispatch, getState) => {
        const state = getState();

        const elementId = getCurrentBoardIdFromState(state);
        const permissionId = getClosestPermissionIdForElementIdSelector()(state, { elementId });

        const result = await validatePermissionPasswordHttp({ elementId, password, permissionId });

        if (!result.success) throw new AppError({ message: 'Something went wrong' });

        // Load token
        dispatch(handlePermissionTokenResponse(result));

        // Force re-fetch elements on success
        dispatch(
            fetchBoard({
                boardId: elementId,
                force: true,
                loadAncestors: true,
            }),
        );
        // Then this page should disappear and the elements should show
    };

const mapDispatchToProps = (dispatch) => ({
    dispatchOnMountDataFetch: () => dispatch(prefetchPasswordProtectedCurrentBoard()),
    dispatchOnSubmit: ({ password }) => dispatch(onSubmitThunk({ password })),
});

export default connect(null, mapDispatchToProps)(BoardPasswordProtectedFormUI);
